function valueGuard(values) {
  if (typeof values === 'number') {
    return {
      base: values.toString()
    };
  }
  if (typeof values === 'string') {
    return {
      base: values
    };
  }
  return values;
}

export { valueGuard };
